import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Privacy policy / terms / official rules, reachable inside the app (App Store 5.1.1, Google Play User Data policy).
export function LegalLinks({ className = '' }) {
  const { t } = useTranslation();
  const cls = 'hover:text-teal-400 transition-colors';
  return (
    <nav className={`flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-500 ${className}`} data-testid="legal-links">
      <Link to="/privacy-policy" className={cls}>{t('landing.footer.privacy')}</Link>
      <Link to="/terms" className={cls}>{t('landing.footer.terms')}</Link>
      <Link to="/rewards-rules" className={cls}>{t('rewardsRules.link')}</Link>
    </nav>
  );
}
